import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GridBotService } from 'src/app/services/bot.grid.service';
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { spotSocket } from 'src/app/app.module';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { truncateDecimals, toFixedDown } from 'src/app/lib/roundOf';

@Component({
  selector: 'app-gridbotstop',
  templateUrl: './gridbotstop.component.html',
  styleUrls: ['./gridbotstop.component.css']
})
export class GridbotstopComponent {
  @Input() botDetails: any;
  @Output() gotoStep = new EventEmitter<any>();

  loader = false;
  posData: any = [];
  pairData: any = {}
  isSubmitting = false;
  tickerData: any = {}
  PnL: number = 0
  RealizedPnl: number = 0
  receiveAmount: number = 0
  currentTradePair: any = {}
  pendingQuantity: number = 0
  pendingOrderValue: number = 0
  selectedOption: string = 'keep';
  showLoaderPage = false
  loaderPercentage = 0
  truncateDecimals = truncateDecimals
  parseFloat: any = parseFloat
  constructor(
    private botFacade: TradePairFacade,
    private marketPriceFacade: MarketPriceFacade,
    private spotSocket: spotSocket,
    private service: GridBotService,
    private toastr: ToastrService,
  ) { }
  closeBot() {
    this.loader = true;
    this.isSubmitting = true;
    this.toastr.success("Please wait for a while")
    this.showBotCreateLoader(true)
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      botId: this.botDetails?._id ? this.botDetails?._id : "",
      // stopMarket: true
      stopMarket: this.selectedOption !== "convert"
    };
    this.service.closeBot(reqData)
      .subscribe({
        next: (v: any) => {
          this.loader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
          this.isSubmitting = false;
          this.gotoStep.emit("one")
        },
        error: (err: any) => {
          this.showBotCreateLoader(false)
          this.loader = false;
          this.isSubmitting = false;

          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  selectOption(option: string) {
    this.selectedOption = option;
  }
  showBotCreateLoader(state: boolean) {
    this.showLoaderPage = state
    this.botTimer(state)
  }

  botTimer(state: boolean) {
    if (state) {
      const interval = setInterval(() => {
        if (this.loaderPercentage < 90) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(interval); // stop at 90%
        }
      }, 1000);
    } else {
      // Finish to 100%
      const finishInterval = setInterval(() => {
        if (this.loaderPercentage < 100) {
          this.loaderPercentage += 10;
        } else {
          clearInterval(finishInterval);
        }
      }, 200);
    }
  }

  marketPriceWs(result: any) {
    if (this.tickerData._id == result.pairId) {
      if (this.posData?.length > 0) {
        let profit = 0
        let RealizedProfit = 0, i = 0;
        for (let item of this.posData) {
          if (item?.sellOrderId?.status == 'pending') {
            let markPrice = parseFloat(result?.data?.bestBid ?? result?.data?.markPrice)
            let entryPrice = (item.buyOrderId.avgPrice * item.buyOrderId.fillQuantity) + item.buyOrderId.fee
            let exitPrice = item.sellOrderId.quantity * markPrice
            let exitfee = exitPrice * (0.1 / 100)
            exitPrice = exitPrice - exitfee
            let orderEstProfit = (exitPrice - entryPrice)
            profit += orderEstProfit
            console.log("fe", 0.1 / 100, item.buyOrderId.fee)
            console.log(i, markPrice, "marketPriceWs", entryPrice, "entryPrice", exitPrice, "exitPrice", "orderEstProfit", orderEstProfit, item?.buyOrderId?.fee)
            console.log("mmmmmmmmmmbuyOrderId", item.buyOrderId.avgPrice, item.buyOrderId.fillQuantity)
            console.log("sellOrderId", item.sellOrderId.avgPrice, item.sellOrderId.quantity)
            i++
          }
          RealizedProfit += item.profit ?? 0
        }
        this.RealizedPnl = truncateDecimals(RealizedProfit, 4)
        this.PnL = truncateDecimals(profit, 4)
      }
    }
  }

  getPosition() {
    this.loader = true;
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      botId: this.botDetails?._id ? this.botDetails?._id : "",
      filter: {
        status: "open",
        limit: 100
      }
    };

    this.service.getPositionHistory(reqData)
      .subscribe({
        next: (v: any) => {
          this.loader = false
          if (v.success) {
            if (v.result?.length > 0) {
              let profit = 0
              let RealizedProfit = 0, i = 0;
              let pendingOrderValue = 0, pendingQuantity = 0
              for (let item of v.result) {
                if (item?.sellOrderId?.status == 'pending') {
                  let markPrice = parseFloat(this.tickerData?.bestBid ?? this.tickerData?.markPrice)
                  let entryPrice = (item.buyOrderId.avgPrice * item.buyOrderId.fillQuantity) + item.buyOrderId.fee
                  let exitPrice = markPrice * item.sellOrderId.quantity
                  // let exitfee = parseFloat(item.buyOrderId.fee)
                  let exitfee = exitPrice * (0.1 / 100)
                  exitPrice = exitPrice - exitfee
                  // exitPrice = exitPrice - (parseFloat(item?.buyOrderId?.fee))
                  let orderEstProfit = (exitPrice - entryPrice)
                  profit += orderEstProfit
                  pendingQuantity += parseFloat(item.sellOrderId.quantity)
                  console.log(i, markPrice, "marketPriceWs", entryPrice, "entryPrice", exitPrice, "exitPrice", "orderEstProfit", orderEstProfit, item?.buyOrderId?.fee)
                  console.log("buyOrderId", item.buyOrderId.avgPrice, item.buyOrderId.fillQuantity, "item.buyOrderId.fee", item.buyOrderId.fee)
                  console.log("sellOrderId", item.sellOrderId.avgPrice, item.sellOrderId.quantity)
                  i++
                }
                if (item?.buyOrderId?.status == 'pending') {
                  pendingOrderValue +=
                    toFixedDown(
                      toFixedDown(item.buyOrderId.price, item.buyOrderId.secondFloatDigit) *
                      toFixedDown(item.buyOrderId.quantity, item.buyOrderId.firstFloatDigit),
                      item.buyOrderId.firstFloatDigit + item.buyOrderId.secondFloatDigit
                    )
                }
                RealizedProfit += item.profit ?? 0
              }
              this.RealizedPnl = truncateDecimals(RealizedProfit, 4)
              this.PnL = truncateDecimals(profit, 4)
              this.pendingOrderValue = truncateDecimals(pendingOrderValue, 4)
              this.pendingQuantity = truncateDecimals(pendingQuantity, 8)
            }
            this.posData = v.result
          }
        },
        error: (err: any) => {
          this.loader = false;
        }
      })
  }

  ngOnInit() {
    this.botFacade.tradePair$.subscribe(tp => {
      this.currentTradePair = tp;
    });
    this.marketPriceFacade.marketPrice$.subscribe({
      next: (pair: any) => {
        this.tickerData = pair
      },

      error: (err: any) => { }
    })
    this.botFacade.tradePair$.subscribe({
      next: (pair: any) => {
        this.pairData = pair
      },
      error: (err: any) => { }
    })
    this.getPosition();
    this.spotSocket.on('marketPrice', this.marketPriceWs.bind(this))
  }

  prevPage() {
    this.gotoStep.emit("three")
  }

}
